import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { OwnTemplateIcon } from 'components/Atoms/Icon';
import { USER_LEVEL_TYPE } from 'constants/common';
import { t } from 'utilities/lang';
const PurchasedTemplate = lazy(() =>
  import('components/Pages/Library/components/Templates')
);

const TemplateDetail = lazy(() => import('components/Pages/TemplateDetail'));

export const ownTemplateRoutes = [
  // Templates
  {
    path: routePath.PURCHASED_TEMPLATE,
    component: PurchasedTemplate,
    name: `${t('route.my')} ${routeName.PURCHASED_TEMPLATE}s`,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.PURCHASED_TEMPLATE },
    ],
    exact: true,
    showMenu: true,
    hasBorderBt: true,
    icon: OwnTemplateIcon,
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.PURCHASED_TEMPLATE_DETAIL,
    component: TemplateDetail,
    exact: true,
    parentName: routeName.PURCHASED_TEMPLATE,
    showOnly: true,
    breadcrumbs: [{ name: routeName.LIBRARY }, { name: t('route.view_details') }],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
];
